import {useEffect, useState} from "react";
import {getCommonCodeGroup} from "../../../../api/api";
import {CFormSelect} from "@coreui/react";

export default (props) => {
	useEffect(() => {

	}, [])

	const handleChange = (e) => {
		const updateRowData = {
			...props.data, value: e.target.value
		}
		props.onEventChange(props.rowIndex, updateRowData);
	}

	return (
		<CFormSelect id={props.data.sectionCd + props.data.itemCd}
					 className={"pt-0 pb-0"}
					 style={{height: 30}}
					 value={props.data.value}
					 onChange={handleChange}
		>
			{props.data.selectValues.map((item, i) => (
				<option style={{height: 30}} value={item.subCode}>{item.codeNm}</option>
			))}
		</CFormSelect>
	)
}
